import React from 'react';
import { useNavigate } from 'react-router-dom';

import Dropdown from 'components/dropdown';
import { RiMoonFill, RiSunFill } from 'react-icons/ri';
import { MdPerson, MdViewHeadline } from 'react-icons/md';

const Navbar = (props: {
  onOpenSidenav: () => void;
  brandText: string;
  secondary?: boolean | string;
}) => {
  const { onOpenSidenav, brandText } = props;
  const [darkmode, setDarkmode] = React.useState(false);
  const navigate = useNavigate();

  const logout = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('admin');
    navigate('/auth/sign-in');
  };

  const admin = JSON.parse(localStorage.getItem('admin'));
  return (
    <nav className="sticky top-4 z-40 flex flex-row flex-wrap items-center justify-between rounded-xl bg-white/10 p-2 backdrop-blur-xl dark:bg-[#0b14374d]">
      <div className="ml-[6px]">
        <a
          href="/admin"
          className="text-lg font-semibold text-gray-600 transition hover:text-gray-800 "
        >
          Home
        </a>
        <p className="shrink text-[33px] font-bold   uppercase text-brand-700 dark:text-white">
          {brandText}
        </p>
      </div>

      <div className="relative mt-[3px] flex h-[61px]  flex-grow flex-grow-0 items-center justify-end gap-6 rounded-full bg-white px-4 py-2 shadow-xl shadow-shadow-500 dark:!bg-navy-800  dark:shadow-none ">
        <div
          className="cursor-pointer text-gray-600"
          onClick={() => {
            if (darkmode) {
              document.body.classList.remove('dark');
              setDarkmode(false);
            } else {
              document.body.classList.add('dark');
              setDarkmode(true);
            }
          }}
        >
          {darkmode ? (
            <RiSunFill className="h-4 w-4 text-gray-600 dark:text-white" />
          ) : (
            <RiMoonFill className="h-4 w-4 text-gray-600 dark:text-white" />
          )}
        </div>
        {/* Profile & Dropdown */}
        <Dropdown
          button={
            <MdPerson className="h-6 w-6 text-gray-600 dark:text-white" />
          }
          children={
            <div className="flex h-48 w-56 flex-col justify-start rounded-[20px] bg-white bg-cover bg-no-repeat shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none">
              <div className="ml-4 mt-3">
                <div className="flex items-center gap-2">
                  <p className="text-sm font-bold text-navy-700 dark:text-white">
                    👋 Hey, {admin.username}
                  </p>{' '}
                </div>
              </div>
              <div className="mt-3 h-px w-full bg-gray-200 dark:bg-white/20 " />

              <div className="ml-4 mt-3 flex flex-col">
                <a
                  href="/admin/profile-settings"
                  className="text-sm text-gray-800 dark:text-white hover:dark:text-white"
                >
                  Profile
                </a>

                <a
                  href=" "
                  className="mt-3 text-sm font-medium text-red-500 hover:text-red-500"
                  onClick={logout}
                >
                  Log Out
                </a>
              </div>
            </div>
          }
          classNames={'py-2 top-8 -left-[180px] w-max'}
        />
      </div>
    </nav>
  );
};

export default Navbar;
